module.exports = {
  cohesionEvents: {
    elementClicked: "redventures.usertracking.v3.ElementClicked",
    elementViewed: "redventures.usertracking.v3.ElementViewed",
    elementSwiped: "redventures.usertracking.v3.ElementSwiped",
  },
};
